import React from 'react';
import { clsx } from 'clsx';
import type { DerivedClientStatus } from './clientStatus';
import { CLIENT_STATUS_LABELS } from './clientStatus';

const STYLES: Record<DerivedClientStatus, string> = {
  activo: 'bg-emerald-50 text-emerald-900 ring-emerald-200/90',
  pendiente: 'bg-amber-50 text-amber-900 ring-amber-200/90',
  moroso: 'bg-rose-50 text-rose-900 ring-rose-200/90',
  suspendido: 'bg-violet-50 text-violet-900 ring-violet-200/90',
  inactivo: 'bg-slate-100 text-slate-600 ring-slate-200/90'
};

export const ClientStatusBadge: React.FC<{ status: DerivedClientStatus; className?: string }> = ({
  status,
  className
}) => (
  <span
    className={clsx(
      'inline-flex items-center rounded-lg px-2.5 py-1 text-xs font-semibold tracking-tight ring-1 ring-inset',
      STYLES[status],
      className
    )}
  >
    {CLIENT_STATUS_LABELS[status]}
  </span>
);
